import cn from "classnames";
import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { formatValue } from "helpers/reports";
import Tooltip from "rc-tooltip";
import React from "react";

/** Render the bid breakdown returned by the trailers report contract. */
export default function TrailerBids({ row, isPrintForm }) {
    if (!row.original?.bids?.length) {
        return null;
    }

    const tableProps = isPrintForm
        ? {
              className: "p-3 reports--bg-bluelight",
              style: { minWidth: "100%", width: row.cells.reduce((acc, cell) => acc + cell.column.width, 0) },
          }
        : { className: "table-responsive" };

    return (
        <div {...tableProps}>
            <table className="table table-sm mb-0 border-bottom border-secondary bg-secondary">
                <thead>
                    <tr className="table-active">
                        <th>#</th>
                        <th>Заявка</th>
                        <th>Контрагент</th>
                        <th>Внешний ID заявки</th>
                        <th>Маршрут</th>
                        <th>Активный, км</th>
                        <th>Порожний, км</th>
                        <th>Общий, км</th>
                        <th>ВАЛ</th>
                        <th>Сред. вес, т</th>
                    </tr>
                </thead>
                <tbody>
                    {row.original.bids.map((item, index) => (
                        <tr
                            key={item.id}
                            className={cn({
                                "r-item__compound-bid": item.compoundBidId,
                                "r-item__mileage-deviation": item.hasOdometerMileageDeviation,
                            })}
                        >
                            <td>{index + 1}</td>
                            <td data-id={item.id}>
                                <a target="_blank" rel="noopener noreferrer" href={paths.bidShow("bid", item.id)}>
                                    {item.id}
                                </a>
                                {item.hasManualMileage && (
                                    <Tooltip overlay="Закрыта вручную" placement="top">
                                        <i className="pl-1 icon-uEA83-user-edit b-point__tooltip-icon" />
                                    </Tooltip>
                                )}
                                {item.compoundBidId && (
                                    <Tooltip overlay="Сборная заявка" placement="top">
                                        <i className="pl-1 b-table__compound-icon icon-uEA76-animation-outline" />
                                    </Tooltip>
                                )}
                                {item.isExpressBid && (
                                    <Tooltip overlay="Экспресс-заявка" placement="top">
                                        <i className="pl-1 icon-uEA90-bolt b-point__tooltip-icon" />
                                    </Tooltip>
                                )}
                                {item.hasTrailerChange && (
                                    <Tooltip overlay="В заявке была осуществлена перецепка" placement="top">
                                        <i className="pl-1 icon-uEAB3-arrows-rotate b-point__tooltip-icon" />
                                    </Tooltip>
                                )}
                                {item.hasEmulatedMileage && (
                                    <Tooltip overlay="В заявке присутствуют эмулированные участки маршрута">
                                        <i className="pl-1 icon-uEACB-emulated-route b-point__tooltip-icon" />
                                    </Tooltip>
                                )}
                                {item.hasOdometerMileageDeviation && (
                                    <Tooltip overlay="Разница между пробегом по плану и по одометру больше 30%">
                                        <i className="pl-1 icon-uEA86-exclamation-circle text-danger" />
                                    </Tooltip>
                                )}
                                {item.hasUncoveredUtmOnPeriod && (
                                    <Tooltip overlay="Часть периода заявки не покрыта данными о сцепке">
                                        <i className="pl-1 icon-uEA86-exclamation-circle text-warning" />
                                    </Tooltip>
                                )}
                            </td>
                            <td data-counterpartyname={item.id}>
                                {hiddenUserData(item.counterpartyName, { type: "title" })}
                            </td>
                            <td data-externalid={item.id}>{item.externalId}</td>
                            <td data-route={item.id}>{item.route}</td>
                            <td data-activemileage={item.id}>{formatValue(item.activeMileage, "double")}</td>
                            <td data-emptymileage={item.id}>{formatValue(item.emptyMileage, "double")}</td>
                            <td data-overallmileage={item.id}>{formatValue(item.overallMileage, "double")}</td>
                            <td data-overallbidprice={item.id}>
                                {hiddenUserData(formatValue(item.overallBidPrice, "double"), { type: "price" })}
                            </td>
                            <td data-averageplanweight={item.id}>{formatValue(item.averagePlanWeight, "double")}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
